type DealIdeaCardProps = {
    title: string;
    description: string;
  };
  
  export const DealIdeaCard = ({
    title,
    description,
  }: DealIdeaCardProps) => {
    return (
      <div>
        <div className="hidden lg:block">
        <div
        className="
          min-h-[192px]
          rounded-[30px]
          bg-[linear-gradient(135deg,rgba(245,230,230,0.72)_0%,rgba(245,230,230,0.62)_100%)]
          transbox
          border-[1.5px] border-white border-solid
          justify-start items-center
          px-8 py-7
          hover:scale-105
          transition
          grid
          text-left
        "
      >
        <h3 className="text-[#111111] text-[22px] leading-[1.2] font-medium">
          {title}
        </h3>
  
        <p className="text-[#1A1A1A] text-[16px] leading-[1.45] max-w-[280px] font-normal">
          {description}
        </p>
      </div>
        </div>

        <div className="block lg:hidden">
        <div
        className="
          h-[120px]
          rounded-[28px]
          
          
         border-[1.5px] border-solid border-white backdrop-blur-lg bg-white/50
          
          px-6 py-6
          text-left
        "
      >
        <h3 className="text-[#111111] text-[14px] leading-[1.2] font-medium">
          {title}
        </h3>
  
        <p className="mt-3 text-[#1A1A1A] text-[12px] leading-[1.45] font-normal max-w-[280px]">
          {description}
        </p>
      </div>
        </div>
      </div>
      
    );
  };